import React, { ReactNode, useState } from "react";
import styles from '../LinkPersonalizado5/linkPersonalizado5.module.scss';
import { useNavigate } from "react-router-dom";

interface LinkPersonalizado5Props {
    href: string;
    isLink?: boolean;
    title: string;
    backgroundColor: string;
    backgroundColorHover: string;
    colorText: string;
    maxWSpan?: boolean;
}

const LinkPersonalizado5: React.FC<LinkPersonalizado5Props> = ({
    href,
    title,
    backgroundColor,
    backgroundColorHover,
    colorText,
    maxWSpan = false,
    isLink = false,
}) => {
    const navigate = useNavigate();
    const [bgColor, setBgColor] = useState(backgroundColor);

    return (
        isLink ?
            <div
                style={{
                    background: bgColor,
                    transition: "background 0.5s ease",
                    display: "block",
                    padding: "10px 20px",
                    margin: "10px 0",
                    textDecoration: "none",
                    color: "black",
                    borderRadius: "8px"
                }}
                onClick={() => navigate(href)}
                onMouseEnter={() => setBgColor(backgroundColorHover)}
                onMouseLeave={() => setBgColor(backgroundColor)}
            >

                <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-center`}>
                    <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                        <span style={{ color: colorText, fontWeight: "bold", fontSize: 16 }}>{title}</span>
                    </div>
                </div>
            </div>
            :
            <a
                href={href}
                target="_blank"
                rel="noreferrer"
                style={{ background: bgColor, transition: "background 0.5s ease" }}
                onMouseEnter={() => setBgColor(backgroundColorHover)}
                onMouseLeave={() => setBgColor(backgroundColor)}
            >
                <div className={`${styles["h-40px"]} d-flex align-items-center justify-content-center`}>
                    <div className={maxWSpan ? styles["max-w-span"] : styles["min-w-span"]}>
                        <span style={{ color: colorText, fontWeight: "bold", fontSize: 14 }}>{title}</span>
                    </div>
                </div>
            </a>
    );
};

export default LinkPersonalizado5;
